export interface EnrichedSupplierItem {
  supplierName: string;
  supplierId: string;
  distanceKm: number;
  coverage: number;
  label: string;
  count: number;
  isPartial?: boolean;
  isRefined?: boolean;
  isAssociated?: boolean;
  fulfilledCount?: number;
  fulfilledPercent: number;
  totalParts?: number;
  totalPartPercentage: number;
  supplierCity?: string;
}

export enum SupplierDiscoverySortOptions {
  DISTANCE = "distance",
  AVAILABILITY = "",
  FULFILLEDPERCENTAGE = "fulfilledPercentage",
  TOTALPARTSPERCENTAGE = "totalPartsPercentage",
}

export enum BucketType {
  IN_PROGRESS = "inProgress",
  SAVED = "saved",
}
